// Colors from the Okabe-Ito color palette
export const COLORS = {
  sex: {
    'Male': '#0072B2',
    'Female': '#E69F00'
  },
  race: {
    "All": "#950b30",
    "Black or African American": "#0072B2",
    "American Indian or Alaska Native": "#009E73",
    "White": "#56B4E9",
    "Asian": "#D55E00",
    "Hispanic": "#E69F00",
    "Native Hawaiian or Other Pacific Islander": "#CC79A7",
  },
  base: "#0072B2",
}

export const SYMBOLS = {
  sex: {
    'Male': 'Cross',
    'Female': 'Diamond'
  },
  race: {
    "All": "Circle",
    "Black or African American": "Cross",
    "American Indian or Alaska Native": "Diamond",
    "White": "Square",
    "Asian": "Star",
    "Hispanic": "Triangle",
    "Native Hawaiian or Other Pacific Islander": "Wye",
  },
  base: "circle",
}